import React, { useState, useEffect, useContext } from "react";
import { Badge, Table, Modal } from "react-bootstrap";
import { httpService } from "../httpService";
import { Typography, Button, Avatar } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import OfficialsWidgets from "./OfficialsWidgets";
import { AlertContext, RefreshContext } from "../contexts/AlertContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faUser } from "@fortawesome/free-solid-svg-icons";
import MyPagination from "../components/MyPagination";
import Swal from "sweetalert2";

export default function RegistrationPage() {
  const [results, setResults] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const [show, setShow] = useState(false);
  const { setLoading } = useContext(RefreshContext);
  const { setAlertData } = useContext(AlertContext);
  const [participant, setParticipant] = useState({});
  const [deleting, setDeleting] = useState(false);

  const handleClose = () => {
    setShow(false);
    setParticipant({});
  };
  const getData = async () => {
    setLoading(true);
    const { data } = await httpService.get(
      `viewregistrations?page=${1}&limit=${50}`
    );

    if (data) {
      setResults(data.results);
      setStartIndex(data.startIndex);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();

    const timer = setInterval(() => {
      getData();
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);

  const viewRegistration = async (e) => {
    setParticipant(e);
    setShow(true);
  };

  const deleteRegistration = () => {
    Swal.fire({
      icon: "question",
      title: "Provide Password",
      input: "text",
    }).then(async (result) => {
      if (result.value && result.value === "jamb123") {
        setDeleting(true);
        const { data, error } = await httpService.delete(`${participant._id}`);
        if (data) {
          setAlertData({ open: true, message: data, severity: "success" });
          setParticipant({});
          setShow(false);
        }

        if (error) {
          setAlertData({ open: true, message: error, severity: "error" });
          setParticipant({});
          setShow(false);
        }
        setDeleting(false);
      }
      if (result.value && result.value !== "jamb123") {
        Swal.fire({ icon: "error", title: "Password Incorrect" });
      }
    });
  };
  return (
    <div>
      <OfficialsWidgets />
      <div className="mt-5 mb-5 container tableOverflow">
        <Table borderless striped>
          <thead>
            <tr>
              <th>S/N</th>
              <th>Name</th>
              <th>Role</th>
              <th>Institution</th>
              <th>Code</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {results.map((c, i) => (
              <tr onClick={() => viewRegistration(c)} key={i}>
                <td className="col-lg-1">{i + startIndex}</td>
                <td className="col-lg-2">
                  <Typography>
                    {c.firstName} {c.lastName}
                  </Typography>
                </td>
                <td className="col-lg-2">
                  <Typography>{c.role}</Typography>
                </td>
                <td className="col-lg-5">
                  <Typography>{c.institution}</Typography>
                </td>
                <td>
                  <Typography>{c.code}</Typography>
                </td>
                <td className="col-lg-1">
                  {c.status === "complete" && (
                    <Badge bg="success">{c.status}</Badge>
                  )}
                  {c.status === "incomplete" && (
                    <Badge bg="warning">{c.status}</Badge>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <MyPagination
          rootPath={"viewregistrations?"}
          setResults={setResults}
          setStartIndex={setStartIndex}
        />
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {participant.title} {participant.firstName}'s profile
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-4">
              {participant.imageURL ? (
                <img
                  className="img-thumbnail"
                  src={participant.imageURL}
                  alt={participant.code}
                />
              ) : (
                <div>
                  <Avatar variant="rounded" sx={{ height: 150, width: 170 }}>
                    <FontAwesomeIcon icon={faUser} />
                  </Avatar>
                </div>
              )}
            </div>
            <div className="col-lg-8">
              <div className="mb-1">
                <Typography variant="caption">Name:</Typography>
                <Typography>
                  {participant.title} {participant.firstName}{" "}
                  {participant.lastName}
                </Typography>
              </div>
              <div className="mb-1">
                <Typography variant="caption">Institution:</Typography>
                <Typography>{participant.institution}</Typography>
              </div>
              <div className="mb-1">
                <Typography variant="caption">Role:</Typography>
                <Typography>{participant.role}</Typography>
              </div>
              <div className="mb-1">
                <Typography variant="caption">Code:</Typography>
                <Typography>{participant.code}</Typography>
              </div>
              <div className="mb-1">
                <Typography variant="caption" gutterBottom>
                  Registration Status:{" "}
                </Typography>
                {participant.status === "complete" && (
                  <Badge bg="success">{participant.status}</Badge>
                )}
                {participant.status === "incomplete" && (
                  <Badge bg="warning">{participant.status}</Badge>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button color="error" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
